import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";

import ColorPaletteField from "../ColorPaletteField";
import { normalizeHexColor } from "../../helpers/colorPalette";

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
  const [selectedColor, setSelectedColor] = useState(
    normalizeHexColor(currentColor)
  );

  useEffect(() => {
    if (open) {
      setSelectedColor(normalizeHexColor(currentColor));
    }
  }, [open, currentColor]);

  const apply = (hex) => {
    const next = normalizeHexColor(hex);
    setSelectedColor(next);
    onChange(next);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="color-picker-dialog"
      open={open}
      fullWidth
      maxWidth="xs"
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <DialogContent>
        <ColorPaletteField value={selectedColor} onChange={apply} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="contained">
          Listo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPicker;
